(function () {
  // ===== CONFIG =====
  const PUBLIC_KEY = "XvxqyA"; // Klaviyo Public API Key / Site ID (6 chars)
  const NEWSLETTER_LIST_ID = "YATXCk"; // Your Klaviyo List ID

  const PROFILE_URL = `https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(PUBLIC_KEY)}`;
  const EVENT_URL   = `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(PUBLIC_KEY)}`;
  const SUBSCRIBE_URL = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(PUBLIC_KEY)}`;

  // Klaviyo requires a revision header in format YYYY-MM-DD
  const KLAVIYO_HEADERS = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "revision": "2024-02-15"
  };

  // ===== HELPERS =====
  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return (div.textContent || div.innerText || "").trim();
  }

  function getLeadValues(form) {
    const fd = new FormData(form);

    const name = (fd.get("name") || "").toString().trim();
    const email = (fd.get("email") || "").toString().trim();
    const postal_code = (fd.get("postal_code") || "").toString().trim();

    // NOTE: your checkbox name is "optout" but copy is opt-in.
    // We'll treat checked=true as opted-in.
    const marketing_opt_in_checked = fd.get("optout") ? true : false;

    return { name, email, postal_code, marketing_opt_in_checked };
  }

  async function klaviyoCreateOrUpdateProfile({ email, name, postal_code }) {
    const body = {
      data: {
        type: "profile",
        attributes: {
          email: email,
          first_name: name || undefined,
          location: postal_code ? { zip: postal_code } : undefined
        }
      }
    };

    if (!body.data.attributes.first_name) delete body.data.attributes.first_name;
    if (!body.data.attributes.location) delete body.data.attributes.location;

    const res = await fetch(PROFILE_URL, {
      method: "POST",
      headers: KLAVIYO_HEADERS,
      body: JSON.stringify(body),
      keepalive: true
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`Klaviyo profile failed: ${res.status} ${txt}`);
    }
  }

  async function klaviyoSubscribeToList(listId, email) {
  const body = {
    data: {
      type: "subscription",
      attributes: {
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: email
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: "list",
            id: listId
          }
        }
      }
    }
  };

  const res = await fetch(SUBSCRIBE_URL, {
    method: "POST",
    headers: {
      ...KLAVIYO_HEADERS,
      "Content-Type": "application/vnd.api+json"
    },
    body: JSON.stringify(body),
    keepalive: true
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Klaviyo subscribe failed: ${res.status} ${txt}`);
  }
}

  async function klaviyoTrackQuizCompleted(email, properties) {
    const body = {
      data: {
        type: "event",
        attributes: {
          metric: { data: { type: "metric", attributes: { name: "Quiz Completed" } } },
          profile: { data: { type: "profile", attributes: { email } } },
          properties: properties
        }
      }
    };

    const res = await fetch(EVENT_URL, {
      method: "POST",
      headers: KLAVIYO_HEADERS,
      body: JSON.stringify(body),
      keepalive: true
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(`Klaviyo event failed: ${res.status} ${txt}`);
    }
  }

  async function handleSubmit(form) {
    const lead = getLeadValues(form);
    if (!lead.email) {
      console.warn("Klaviyo: email missing, not sending.");
      return;
    }

    // Force collect answers (best)
    let answers = {};
    if (window.EnlightenQuiz?.collectAllAnswers) {
      answers = window.EnlightenQuiz.collectAllAnswers() || {};
    } else if (window.EnlightenQuiz?.getAnswers) {
      answers = window.EnlightenQuiz.getAnswers() || {};
    }

    const regime = window.EnlightenQuiz?.getRegime ? window.EnlightenQuiz.getRegime() : null;

    const props = {
      quiz_name: "Enlighten Quiz",
      quiz_completed_at: new Date().toISOString(),

      quiz_regime_id: regime?.id || "",
      quiz_regime_name: stripHtml(regime?.name || ""),

      quiz_answers: answers,

      lead_name: lead.name,
      lead_postal_code: lead.postal_code,
      marketing_opt_in_checked: lead.marketing_opt_in_checked
    };

    // 1) Create/Update profile (always)
    await klaviyoCreateOrUpdateProfile(lead);

    // 2) Subscribe to list ONLY if opted-in
    if (lead.marketing_opt_in_checked) {
      await klaviyoSubscribeToList(NEWSLETTER_LIST_ID, lead.email);
      console.log("✅ Klaviyo subscribed to list", { email: lead.email, listId: NEWSLETTER_LIST_ID });
    } else {
      console.log("ℹ️ Klaviyo: not opted in, skipping list subscribe", { email: lead.email });
    }

    // 3) Track event (always)
    await klaviyoTrackQuizCompleted(lead.email, props);

    console.log("✅ Klaviyo sent: profile + Quiz Completed", {
      email: lead.email,
      quiz_regime_id: props.quiz_regime_id
    });
  }

 // ===== ATTACH LISTENER (CLICK-BASED, BULLETPROOF) =====
document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("enlighten-quiz");
  if (!root) return;

  const form = root.querySelector('form[data-form="lead"]');
  if (!form) {
    console.warn("Klaviyo: lead form not found (#enlighten-quiz form[data-form='lead']).");
    return;
  }

  // Your submit button has: class="eq-button--reveal"
  const btn = form.querySelector('button[type="submit"], .eq-button--reveal');
  if (!btn) {
    console.warn("Klaviyo: reveal/submit button not found in lead form.");
    return;
  }

  btn.addEventListener("click", function () {
    handleSubmit(form).catch((err) => console.error("❌ Klaviyo submit error:", err));
  });

  console.log("✅ Klaviyo listener attached to reveal button click");
});
})();